module.exports = __webpack_public_path__ + "img/pickaxe-stone.d0f18f7c.svg";